import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import createUrl from '../resources/createUrl';
import generateUrl, { AvailablePages } from '../resources/generateUrl';

import style from './TransparencyBanner.module.less';

const TransparencyBanner = () => {
  const { locale } = useIntl();
  const MISSION_URL = createUrl(
    generateUrl(locale, 'about/our-story', AvailablePages.ABOUT_OUR_STORY),
  );
  const DISCLAIMER_URL = createUrl(
    generateUrl(locale, 'compare/disclaimer', AvailablePages.COMPARISON_DISCLAIMER),
  );

  return (
    <div className={style['transparency-banner__footer']}>
      <div className={style['transparency-banner__slogan']} role="heading" aria-level={2}>
        <FormattedMessage id="no-hidden-fees" />
      </div>
      <p className={style['transparency-banner__text']}>
        <FormattedMessage id="disclaimer-mission" />
        &nbsp;
        <a href={MISSION_URL}>
          <FormattedMessage id="disclaimer-without-borders" />
        </a>
        &nbsp;
        <FormattedMessage id="disclaimer-charges" />
        &nbsp;
        <a href={DISCLAIMER_URL}>
          <FormattedMessage id="disclaimer-how-do-we-collect" />
        </a>
      </p>
    </div>
  );
};

export default TransparencyBanner;
